import { render, staticRenderFns } from "./FineRecord.vue?vue&type=template&id=9cbd0044&scoped=true"
import script from "./FineRecord.vue?vue&type=script&lang=js"
export * from "./FineRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbd0044",
  null
  
)

export default component.exports